
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Import environment config synchronously
import { config } from './config/env.ts';

// Log environment status for debugging
console.log('Environment config loaded:', {
  isDev: config.app.isDev,
  isProd: config.app.isProd,
  hasGoogleClientId: !!config.google.clientId,
  hasApiBaseUrl: !!config.api.baseUrl,
});

createRoot(document.getElementById("root")!).render(<App />);
